import './FileTable.scss';

export { default } from './FileTable';
